"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const sok_types_1 = require("@caddigital/sok-types");
const ActionTypes = require("../../../actionTypes/vektorio/linkFolders");
const utils_1 = require("../utils");
const status_1 = require("../../../status");
const statuses = (0, utils_1.createRequestStatus)(status_1.RequestType.FETCH);
exports.initialState = {
    isOpen: false,
    mode: sok_types_1.Vektorio.ROOT,
    status: statuses.standby()
};
const isOpenLens = monocle.Lens.fromProp('isOpen');
const modeLens = monocle.Lens.fromProp('mode');
const statusLens = monocle.Lens.fromProp('status');
const methods = {};
exports.methods = methods;
methods[ActionTypes.LINK_REQUEST] = (state) => statusLens.set(statuses.fetching())(state);
methods[ActionTypes.LINK_SUCCESS] = (state) => fp.function.flow(statusLens.set(statuses.success()), isOpenLens.set(false))(state);
methods[ActionTypes.LINK_FAILURE] = (state) => statusLens.set(statuses.failed())(state);
methods[ActionTypes.SET_MODE] = (state, action) => modeLens.set(action.payload)(state);
methods[ActionTypes.TOGGLE_SIDE_MENU] = (state) => isOpenLens.modify((isOpen) => !isOpen)(state);
methods[ActionTypes.CLEAR] = () => (Object.assign({}, exports.initialState));
//# sourceMappingURL=index.js.map